// Jace: Show Add To Cart button on mobile (home page - featured products)    
/*
var shop_domain = Shopify.shop;
if (!window.jQuery) {
    var sc = document.createElement("script");
    sc.type = "text/javascript";
    sc.src = "https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js";
    sc.onload = start;
    document.head.appendChild(sc);
} 
*/

$(document).ready( function() {
  $(".jace-add-to-cart-btn-mobile").submit( function(e) {
    e.preventDefault();
    console.log("Foo");
    var vId = $(this).find("input[name='id']").val();
    var quan = $(this).find("input[name='quantity']").val();
    $.ajax({ 
      url:'/cart/add.js',
      type:'post',
      dataType:'json',
      data:{
        id:vId,
        quantity:quan
      }, 
      async:false,
      success: function (data) { 
        window.location.href='/';
      },
      error: function(msg) {
        console.log(msg);
      }	
    }); 
  });
});